"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMaxRedeemableLoyaltyInCents = exports.convertCentsToLoyaltyPoints = exports.convertLoyaltyPointsToCents = void 0;
const constants_1 = require("../constants");
const convertLoyaltyPointsToCents = (loyaltyPoints, loyaltyPointsMultiplier) => {
    if (loyaltyPointsMultiplier === undefined) {
        loyaltyPointsMultiplier = 100;
    }
    // Multiply before dividing so the imprecise `multiplier / 100` value is never formed.
    // e.g. 90 * (70 / 100) === 62.99999999999999 -> floor 62, which short-changes the customer.
    return Math.floor((loyaltyPoints * loyaltyPointsMultiplier) / constants_1.LOYALTY_POINT_CONSTANT);
};
exports.convertLoyaltyPointsToCents = convertLoyaltyPointsToCents;
const convertCentsToLoyaltyPoints = (centValue, loyaltyPointsMultiplier) => {
    if (loyaltyPointsMultiplier === undefined) {
        loyaltyPointsMultiplier = 100;
    }
    else if (loyaltyPointsMultiplier === 0) {
        return 0;
    }
    // Multiply before dividing so the imprecise `multiplier / 100` value is never formed.
    // e.g. 21 / (70 / 100) === 30.000000000000004 -> ceil 31, which over-debits the customer.
    return Math.ceil((Math.abs(centValue) * constants_1.LOYALTY_POINT_CONSTANT) / loyaltyPointsMultiplier);
};
exports.convertCentsToLoyaltyPoints = convertCentsToLoyaltyPoints;
const getMaxRedeemableLoyaltyInCents = (params) => {
    const maximumAllowedLoyaltyInCents = params.creditBalanceInCents === undefined
        ? params.subTotal
        : Math.min(params.subTotal, params.creditBalanceInCents);
    const minAllowableCannabisDiscountedPrice = 1 * params.complianceProductCount; // Each cannabis product must be sold at $0.01 or greater
    const subTotalAfterDiscount = params.subTotal - maximumAllowedLoyaltyInCents;
    const isDiscountedPriceBelowMinimum = subTotalAfterDiscount < minAllowableCannabisDiscountedPrice;
    return isDiscountedPriceBelowMinimum
        ? params.subTotal - minAllowableCannabisDiscountedPrice
        : maximumAllowedLoyaltyInCents;
};
exports.getMaxRedeemableLoyaltyInCents = getMaxRedeemableLoyaltyInCents;
//# sourceMappingURL=utilties.js.map